import { render, staticRenderFns } from "./chatMsgItem.vue?vue&type=template&id=0aa30184&scoped=true&"
import script from "./chatMsgItem.vue?vue&type=script&lang=js&"
export * from "./chatMsgItem.vue?vue&type=script&lang=js&"
import style0 from "./chatMsgItem.vue?vue&type=style&index=0&id=0aa30184&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa30184",
  null
  
)

export default component.exports